import { useSiteContext, formatPrice, Currency } from '@zooplus/commons-lang';

export const usePriceFormatter = () => {
  const { locale } = useSiteContext();

  function formatPriceWithLocale(price: number, currency: Currency, rounding: boolean = false) {
    return formatPrice(
      rounding ? roundPriceWithCurrency(price, currency) : price,
      locale,
      currency,
    );
  }

  return formatPriceWithLocale;
};

/** Round price with provided decimals precision */
const roundPrice = (price: number, decimals: number = 2) => {
  const factor = Math.pow(10, decimals);
  return Math.round(price * factor) / factor;
};

/** Return rounded price with decimals precision depending on currency */
const roundPriceWithCurrency = (price: number, currency: Currency) => {
  switch (currency) {
    case 'CZK':
    case 'HUF':
      return roundPrice(price, 0);
    default:
      return roundPrice(price, 2);
  }
};
